import WaitingRoomContainer from './WaitingRoomContainer';

export default WaitingRoomContainer;
